/**
 * Helpers de fecha sobre date-fns.
 *
 * Reemplazan los usos de moment: moment se importaba en 6 archivos vivos y viajaba
 * completo (~60 KB gzip, con todos sus locales) en el chunk compartido de cada
 * pagina. date-fns ya era dependencia del proyecto y hace tree-shaking por funcion,
 * asi que solo entra lo que se usa.
 *
 * Nota de formato: el token ordinal de moment es 'Do'; en date-fns es 'do'.
 */
import { addDays, format, parseISO } from 'date-fns'

/**
 * Fecha a N dias de hoy, formateada 'MMMM do, yyyy' (ej. "March 3rd, 2026").
 *
 * Devuelve '-' cuando el calculo no da un numero: los llamadores dividen por
 * totales que pueden venir undefined, y moment mostraba "Invalid date" en ese
 * caso mientras date-fns lanzaria RangeError.
 */
export const enDias = dias => {
  const n = Math.trunc(Number(dias))
  if (!Number.isFinite(n)) return '-'

  return format(addDays(new Date(), n), 'MMMM do, yyyy')
}

/** Fecha ISO ('YYYY-MM-DD') a 'MMM do, yyyy' (ej. "Mar 3rd, 2026"). */
export const fechaCorta = iso => {
  if (!iso) return '-'
  const d = parseISO(String(iso))
  if (Number.isNaN(d.getTime())) return '-'

  return format(d, 'MMM do, yyyy')
}

/** Hora local en HH:mm:ss. */
export const horaLocal = () => format(new Date(), 'HH:mm:ss')

/** Hora UTC en HH:mm:ss. */
export const horaUtc = () => new Date().toISOString().slice(11, 19)

/** Dia de la semana en UTC (0 = domingo), como moment.utc().day(). */
export const diaSemanaUtc = () => new Date().getUTCDay()

/** Anio actual. */
export const anioActual = () => new Date().getFullYear()
